import React from "react";

import type { ResourceTypeUI } from "../../domains/resource/types";

import { DatabaseIcon, CacheIcon, QueueIcon, ConnectionIcon } from "./icons";

const ICON_MAP: Record<ResourceTypeUI, React.FC<{ size?: number }>> = {
  postgres: DatabaseIcon,
  redis: CacheIcon,
  rabbitmq: QueueIcon,
  nats: ConnectionIcon,
  kafka: QueueIcon,
  pulsar: ConnectionIcon,
};

const LABEL_MAP: Record<ResourceTypeUI, string> = {
  postgres: "PostgreSQL",
  redis: "Redis",
  rabbitmq: "RabbitMQ",
  nats: "NATS",
  kafka: "Kafka",
  pulsar: "Pulsar",
};

export function ResourceIcon({
  type,
  size = 20,
}: {
  type: ResourceTypeUI;
  size?: number;
}): React.ReactElement {
  const Icon = ICON_MAP[type] ?? DatabaseIcon;
  return <Icon size={size} />;
}

export function ResourceLabel({ type }: { type: ResourceTypeUI }): string {
  return LABEL_MAP[type] ?? type;
}
